import moment from "moment";

export const toYearMonth = (value) => {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}$/.test(value)) return value;
  if (typeof value === "string") {
    const match = value.match(/^(\d{4}-\d{2})/);
    if (match) return match[1];
  }
  const m = moment.utc(value);
  return m.isValid() ? m.format("YYYY-MM") : null;
};

export const formatMonthLabel = (value) => {
  const ym = toYearMonth(value);
  if (!ym) return "—";
  return moment(ym, "YYYY-MM").format("MMM YYYY");
};

export const formatRangeLabel = (start, end) => {
  const startLabel = formatMonthLabel(start);
  const endLabel = formatMonthLabel(end);
  if (startLabel === "—" && endLabel === "—") return "—";
  return `${startLabel} – ${endLabel}`;
};

export const isValidMonthRange = (startMonth, endMonth) => {
  if (!startMonth || !endMonth) return false;
  return endMonth >= startMonth;
};
